import React from "react"
import Layout from "../components/layout/layout"
import Container from "../components/layout/container"
import Content from "../components/content/Content"
import Sidebar from "../components/content/Sidebar";
import Box from "../components/content/Box";
import SchemaStars from "../components/schemastars"
import Stars from "../components/stars"
import Anchor from "../components/content/Anchor";
import Lightbox from "../components/content/Lightbox";
import TextWithTeaser from "../components/content/TextWithTeaser";
import OnOff from "../components/content/OnOff";
import Paginate from "../components/paginate"
import QuoteStepsModal from '../components/quote-steps-modal'
import { type } from "jquery";

const PROFILELANDINGPAGE = ({ pageContext }) => 
{     
    const page = pageContext
    const code = page.code
    const env = page.env 
    const main_menu = page.main_menu
    const footer_menu = page.footer_menu
    const profile = page.profile 

    // Modals
    
    const showQuoteModal = profile.showmodal
    const showBookModal = false 

    // SEO

    const getSeoDesc = (profile) =>
    {
        return profile.description.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
    }

    const getSeoTitle = (profile) =>
    {
        return profile.name+', '+profile.profile.add_c+', '+profile.profile.add_av
    }

    const seoImage = (image) =>
    {
        if(image.path !== undefined)
        {
            return image.path
        }

        return false
    }

    const seo = 
    {
        url: profile.url,
        env: env,
        title: getSeoTitle(profile),
        description: getSeoDesc(profile),
        code: code,
        page: 'profile',
        image: seoImage(profile.profile.logo)
    }

    // ---------------- 

    const BreadCrumb = () =>
    {        
        const links = profile.breadcrumb

        if(links.lenght < 2) return <></>

        const partOne = () =>
        {
            if(links[0] !== undefined && links[0] !== null)
            {                 
                return(
                    <a className="state" href={links[0].url}>{links[0].label}</a>
                )
            }

            return <></>
        }

        const partTwo = () =>
        {
            if(links[1] !== undefined && links[1] !== null)
            {            
                return(
                    <>
                    <span>{' >'}</span> <a href={links[1].url}>{links[1].label}</a>
                    </>
                )
            }

            return <></>
        }
        
        return(
            <Container classes="bread">
                <div className="col-12">
                    {partOne()}{partTwo()}
                </div>
            </Container>
        )
    }

    const reviewForm = () =>
    {
        if (typeof window !== "undefined") window.open('https://hometown.wufoo.com/forms/m7a4z7/def/field325=905558927&amp;field2=Container+Pro&amp;field334=1073725448',  null, 'height=600, width=680, toolbar=0, location=0, status=1, scrollbars=1, resizable=1'); 
        
        return false
    }

    const ProCardBanner = () =>
    {        
        const rates = [] 
        const fixedcode = code === 'dumpster' ? 'junk-removal' : 'demolition-contractor';
        const services = profile.serviceslinks[0]

        page.reviews.map(review =>
        {
            rates.push(review.stars)
        })  

        const ServicesLinks = () =>
        {            
            services.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0)) 
            
            return(
                <ul className="service_links">
                {
                    services.map(service =>
                    {
                        if(service)
                        {                            
                            return(
                                <li><a href={service.url}>{service.label}</a></li>
                            )
                        }

                        return <></>                      
                    })    
                }
                </ul>
            )
        }

        return(
            <div className="profile-banner">                                                            
                <div className="profile-banner">
                    <div className="row">
                        <div className="col-12">
                            <div className="post">
                                <h1 className="main-title"><span itemprop="name">{profile.name}</span></h1>                         
                                <SchemaStars reviews profile calculate={rates} />                                            
                                <ServicesLinks />                            
                                <div className="actions">
                                    {showQuoteModal &&
                                    <div className="modal_box">
                                        <a href="#" className="service fire-modal" data-keygroup={fixedcode}>Get a Quote</a>
                                    </div>}

                                    {showBookModal &&
                                    <div className="modal_box">
                                        <a href="#" className="book fire-book-modal" data-keygroup={fixedcode}>Book a Dumpster</a>
                                    </div>} 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const SidebarCard = () =>
    {                
        const fixedcode = code === 'dumpster' ? 'junk-removal' : 'demolition-contractor'
        const hideAddress = profile.profile.hide_address
        const unpaid = profile.profile.unpaid

        const addPhone = (phone) =>
        {   
            if(unpaid) return <></>

            const showPhone = (e) =>
            {            
                e.currentTarget.classList.add('show')    
            }
            
            if(phone !== '')
            {
                return(
                    <>
                    <div className="phonemanager mobile"> 
                        <img src="/p-phone.svg" />
                        <span className="phone"><a className="pro-phone-cont" data-proid={profile.profile.id} href={'tel://'+phone}><span className="pro-phone-cont" data-proid={profile.profile.id} itemprop="telephone">Call Now</span></a></span>
                    </div>
                    <div onClick={showPhone} className="phonemanager desktop" data-proid={profile.profile.id}> 
                        <img src="/p-phone.svg" />                        
                        <div className="pro-phone-cont handler" data-proid={profile.profile.id}>See phone number</div>
                        <span className="phone"><a href={'tel://'+phone}><span itemprop="telephone">{phone}</span></a></span>
                    </div>
                    </>
                )
            }

            return <></>;
        }

        const addWebsite = () =>
        {   
            if(unpaid || profile.profile.website === '') return <></>

            const website = profile.profile.website.length > 35 ? 'Visit website' : profile.profile.website
            
            return(
                <div className="websitemanager"> 

                    <img src="/p-web.svg" />       

                    <span className="website"><a target="_blank" className="pro-website-cont" data-proid={profile.profile.id} href={profile.profile.website}><span className="pro-website-cont" data-proid={profile.profile.id} itemprop="website">{website}</span></a></span>

                </div>
            )
        }

        const addLogo = (image, name) =>
        {
            const defaultimg = env.site === 'dumpster' ? '/default-dumpster-clp.png' : '/default-demolition-clp.png';

            if(image.path !== undefined)
            {
                return(
                    <div className="images" itemprop="image" itemscope="itemscope" itemtype="http://schema.org/ImageObject"> 
                        <img itemprop="url" src={image.path} alt={name+' logo'}/>                            
                    </div>                   
                )
            }

            return (
                <div className="images" itemprop="image" itemscope="itemscope" itemtype="http://schema.org/ImageObject"> 
                    <img itemprop="url" src={defaultimg} alt={env.site}/>                               
                </div>                   
            )
        }

        const addAddress = () =>
        {
            if(hideAddress)
            {
                return(
                    <ul className="address" itemprop="address" itemscope="itemscope" itemtype="https://schema.org/PostalAddress">                       
                        { profile.profile.address_alternative && <li className="street" itemprop="addressRegion"><img src="/p-address.svg" />  {profile.profile.address_alternative}</li> }
                    </ul>
                )
            }

            return(
                <ul className="address" itemprop="address" itemscope="itemscope" itemtype="https://schema.org/PostalAddress">
                    { profile.profile.address !== '' && <li className="street" itemprop="streetAddress"><img src="/p-address.svg" />  {profile.profile.address}</li>}
                    { profile.profile.address_extras && <li className="region" itemprop="addressRegion">{profile.profile.address_extras}</li> }
                </ul>
            )
        }
        
        return(
            <div className="info">
                {addLogo(profile.profile.logo, profile.name)}

                <h2>Contact</h2>
                <div className="phone_box">
                    {addPhone(profile.profile.phone)} 
                </div> 
            
                {addAddress()}
                    
                <div className="webiste_box">
                    {addWebsite()}
                </div>                                                             

                {showQuoteModal &&
                <div className="modal_box">
                    <a href="#" className="service fire-modal" data-keygroup={fixedcode}>Get a Quote</a>
                </div>}
                    
            </div>              
        )
    }    

    const Description = () =>
    {
        if(profile.description === '') return <></>           
                        
        return(
            <div className="profile-description">
                <h2>Description</h2>                                
                <Anchor name="profile" />            
                <TextWithTeaser danger={true} >{profile.description}</TextWithTeaser>
            </div> 
        )
    }

    const Message = () =>
    {
        const text = env.site === 'dumpster' ? "America's #1 Source for Dumpsters and Junk Removal" : "America's #1 Source for Local Demolition Experts";        
    
        return(
            <div className="profile-message">
                <h3>{text}</h3>
            </div>  
        )
    }

    const Services = () =>
    {        
        const services = profile.services[0].length > 0 ? profile.services[0] : []

        services.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) 

        if(services.length <= 0) return <></>

        const projectTypes = () =>
        {
            const types = []
            
            services.map(service =>
            {
                service.types.map(type =>
                {
                    types.push(type)
                })  
            })    

            types.sort()

            return types
        }
    
        return(
            <div className="profile-services">
                <h2>Services</h2>
                <Anchor name="services" />      
                <ul className="names">
                {
                    services.map(service =>
                    {
                        return <li>{service.name}</li>
                    })
                }
                </ul>  
                <ul className="profile-project-types">
                {
                    projectTypes().map(type =>
                    {                                        
                        return <li data-type={type.replace(/ /g,'-').toLowerCase()}>{type}</li>
                    })
                }
                </ul>
                <OnOff target='profile-project-types' offLabel='View all project types >' onLabel='< View less' start="off" />                  
            </div>  
        )
    }

    const Photos = () =>
    {        
        const photos = profile.photos

        if(photos.length <= 0) return <></>
        
        return(
            <div className="profile-photos">
                <h2>Photos</h2>
                <Anchor name="photos" />  
                <Lightbox images={profile.photos} globalt={profile.name} />                                                    
            </div>  
        )
    }

    const Reviews = () =>
    {        
        const reviews = page.reviews

        if(reviews.length <= 0) 
        return (
            <div className="profile-reviews">
                <h2>Verified Reviews</h2>
                <Anchor name="reviews" />   
                <div className="write">
                    <div class="text">Be the first to add a review for {profile.name}</div>
                    <a href="#" onClick={reviewForm} title="Write a Review" rel="nofollow">Write a Review</a>
                </div>
            </div>     
        )
    
        return(
            <div className="profile-reviews">
                <h2>Verified Reviews</h2>
                <Anchor name="reviews" />   
                <div className="write">
                    <span>{profile.name}</span>
                    <a href="#" onClick={reviewForm} title="Write a Review" rel="nofollow">Write a Review</a>
                </div>                                                                                
                <Paginate perpage={5} class="blogs" topnav={false} anchor={'reviews'}>
                <div className="blogs"> 
                {
                    reviews.map((review,index) =>
                    {                                                
                        return(
                            <div key={index} className="single-item review">
                                <Stars rate={review.stars}/>
                                <div className="user">Review by {review.customer}{(review.place ==='' ? '': ` in ${review.place}`)}</div>
                                <p>{review.text}</p>
                            </div>
                        )
                    })
                }
                </div> 
                </Paginate>
            </div>
        )
    }

    const Areas = () =>
    {        
        const areas = profile.areas

        if(areas.length <= 0) return <></>
        
        return(
            <div className="profile-areas">
                <h2>Cities Served</h2>
                <Anchor name="areas" />  
                <ul className="areas">              
                {
                    areas.map(area =>
                    {
                        const name = Math.random().toString(36).substr(2, 9)

                        const toggle = (e) =>
                        {
                            const target = document.getElementsByClassName(e.currentTarget.dataset.target)[0]

                            if(target.classList.contains('on')) 
                            {
                                target.classList.remove('on')
                                e.currentTarget.classList.remove('open')
                                return
                            }   

                            target.classList.add('on')
                            e.currentTarget.classList.add('open')
                        }
                        
                        return(
                            <li className="area">
                                <h4 data-target={name} onClick={toggle}>{area.state} <img className="plus" src="/areaplus.svg"/> <img className="less" src="/arealess.svg"/></h4>
                                <ul className={'places '+name}>
                                {
                                    area.places.map(place =>
                                    {
                                        return <li>{place}</li>
                                    })
                                }
                                </ul>
                            </li>
                        )
                    })
                }       
                </ul>                         
            </div>  
        )
    }

    const QuoteModal = () =>
    {
        const fixedcode = code === 'dumpster' ? 'junk-removal' : 'demolition-contractor';

        if(!profile.showmodal) return <></>

        return <QuoteStepsModal env={env} code={fixedcode} modal_project_types={page.modal_project_types} />
    }

    return (
        <Layout seo={seo} env={env} main_menu={main_menu} footer_menu={footer_menu} bgcolor={'#f5f5f5'}>

            <QuoteModal />

            <div className="profile-landing-page" data-proid={profile.profile.id} id="profile-landing-page" itemscope="itemscope" itemtype="https://schema.org/LocalBusiness">
                <Message />  
                <BreadCrumb />  
                <Container>
                    <Content width="col-12">
                        <Box>
                            <ProCardBanner />
                        </Box>
                    </Content>
                </Container>                        
                <Container>
                    <Content>
                        <Box>
                            <Description />
                            <Services />
                            <Photos />
                            <Reviews />
                            <Areas />
                        </Box>
                    </Content>      
                    <Sidebar>
                        <Box>
                            <SidebarCard />
                        </Box>
                    </Sidebar>        
                </Container>
            </div>       
        </Layout>
    )
};

export default PROFILELANDINGPAGE;